var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "px",
    height: "510px",
    viewBox: "0 0 267 509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,58.431373%,10.980392%)",
      fillOpacity: 1,
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 71.33661 740.004136 L 500 4.966471 L 928.66339 740.004136 Z M 71.33661 740.004136 ",
    transform: "matrix(0.267,0,0,0.266632,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,58.431373%,10.980392%)",
      fillOpacity: 1,
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 70.590473 740.004136 L 500 1892.840657 L 929.409527 740.004136 Z M 70.590473 740.004136 ",
    transform: "matrix(0.267,0,0,0.266632,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,58.431373%,10.980392%)",
      fillOpacity: 1,
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 252.340824 740.004136 L 500 7.80864 L 747.659176 740.004136 Z M 252.340824 740.004136 ",
    transform: "matrix(0.267,0,0,0.266632,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,58.431373%,10.980392%)",
      fillOpacity: 1,
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 251.94581 740.5462 L 500 1896.136987 L 748.05419 740.5462 Z M 251.94581 740.5462 ",
    transform: "matrix(0.267,0,0,0.266632,0,0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrange);
export default __webpack_public_path__ + "static/media/orange.df8ce54e81c5411d486b4a24ba83b6f7.svg";
export { ForwardRef as ReactComponent };